import { render, staticRenderFns } from "./StaffClock.vue?vue&type=template&id=2390d90c"
import script from "./StaffClock.vue?vue&type=script&lang=js"
export * from "./StaffClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports